import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const ScreensPage = lazy(() => import("./web/ScreensPage.js").then((m) => ({ default: m.ScreensPage })));
const AdvertsPage = lazy(() => import("./web/AdvertsPage.js").then((m) => ({ default: m.AdvertsPage })));

export default defineWebModule({ manifest, pages: { "": ScreensPage, "/adverts": AdvertsPage } });
